module.exports = __webpack_public_path__ + "8b55a52da51c67b0c499a92797533ef6.png";